(function () {
  var wortel = document.querySelector('[data-spg-bq]');
  if (!wortel) return;
  var cfgEl = wortel.querySelector('[data-spg-bq-config]');
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = {}; }
  var BEELD = CFG.beeld || {};
  var SETS = CFG.sets || {};
  var RUST = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var TYPES = {
    t: { naam: 'de tentoonsteller', kop: 'De tentoonsteller', zin: '"Geen plek meer" betekent dat er een boekenplank bij moet.' },
    s: { naam: 'de sleutelaar', kop: 'De sleutelaar', zin: 'Jij laat niemand naar huis gaan voordat ze hebben gezien hoe de besturing werkt.' },
    v: { naam: 'de verhalenbouwer', kop: 'De verhalenbouwer', zin: 'Bij jou staat een minifiguur nooit zomaar ergens. Die is ergens mee bezig.' },
    e: { naam: 'de eigenbouwer', kop: 'De eigenbouwer', zin: 'Leuk, die foto op de doos. Jouw versie krijgt een extra verdieping.' }
  };

  var RONDES = [
    {
      vraag: 'Het huis is klaar. Wat mist er nog?',
      keuzes: [
        { id: 't', naam: 'Een tuin', sub: 'vol bloemen', een: ['tuin-knop'], twee: [['tuin']], hint: 'Tik op de knopjes',
          zin1: 'Er zit al wat in de grond.', zin2: 'Zo. Hier zou je zelf wel willen wonen.',
          ik: 'Mijn huis kreeg eerst een tuin vol bloemen, met een hekje erom.', alt: 'een tuin vol bloemen met een wit hekje' },
        { id: 's', naam: 'Een garage', sub: 'met een deur die open kan', een: ['garage'], twee: [['garage-half'], ['garage-open-in'], ['garage-rijdt'], ['garage-open']], kat: 'kat-auto', hint: 'Tik op de deur',
          zin1: 'Een garage. Maar gaat die deur ook open?', zin2: 'Hij gaat echt open. En de auto rijdt er meteen uit.',
          ik: 'In mijn huis gaat de garagedeur echt open, en de auto rijdt eruit.', alt: 'een garage met een gele auto op de oprit' },
        { id: 'v', naam: 'Een boefje', sub: 'voor op het dak', een: ['boef-klim'], twee: [['boef-klim-hoog'], ['boef']], hint: 'Tik op het boefje',
          zin1: 'Wie hangt daar aan de regenpijp?', zin2: 'Hij staat op het dak. Wat is hij van plan, en waar blijft de politie?',
          ik: 'Mijn huis stond nog geen minuut of er liep al een boef op het dak.', alt: 'een boefje op de nok van het dak' },
        { id: 'e', naam: 'Een verdieping', sub: 'er kan nog wel wat op', verdieping: true, hint: 'Tik op het dak',
          zin1: 'Het dak kan er nog even af.', zin2: 'Klik. Het huis was af. Toen kreeg je een beter idee.',
          ik: 'Mijn huis was af. Toen kwam er nog een verdieping op.', alt: 'een extra verdieping' }
      ]
    },
    {
      vraag: 'Er komt bezoek. Wat zien ze als eerste?',
      keuzes: [
        { id: 't', naam: 'Een bankje', sub: 'onder een lantaarn bij het pad', een: ['lantaarn'], twee: [['lantaarn-aan']], hint: 'Tik op de lantaarn',
          zin1: 'Een bankje bij het pad. Keurig.', zin2: 'En als het donker wordt, staat het er nog net zo mooi bij.',
          ik: 'Bij mijn huis staat een bankje onder de lantaarn, netjes bij het pad.', alt: 'een bankje onder een brandende lantaarn' },
        { id: 's', naam: 'Een molentje', sub: 'met wieken die draaien', een: ['molen-0'], twee: [['molen-1'], ['molen-2'], ['molen-0']], draai: true, hint: 'Tik op de wieken',
          zin1: 'Een molentje. Zou hij draaien?', zin2: 'Hij draait. En nu wil je weten hoe.',
          ik: 'Naast mijn huis draait een molentje.', alt: 'een molentje met draaiende wieken' },
        { id: 'v', naam: 'De postbode', sub: 'met een pakje', een: ['postbode'], twee: [['postbode-zwaai']], hint: 'Tik op de postbode',
          zin1: 'De postbode, met een pakje. Voor wie zou het zijn?', zin2: 'Hij zwaait. Het pakje is voor jou.',
          ik: 'Bij mijn huis staat de postbode al met een pakje.', alt: 'een postbode met een pakje' },
        { id: 'e', naam: 'Een boomhut', sub: 'die je zelf verzint', een: ['boomhut-kaal'], twee: [['boomhut']], hint: 'Tik op de boomhut',
          zin1: 'Een boomhut. Er moet nog een dak op.', zin2: 'Klik, dak erop. Niemand vroeg erom en iedereen wil erin.',
          ik: 'Naast mijn huis staat een boomhut die in geen enkel boekje stond.', alt: 'een boomhut met een groen dak' }
      ]
    },
    {
      vraag: 'Nog één steentje. Wat maakt het af?',
      keuzes: [
        { id: 't', naam: 'Een vlag', sub: 'bovenop de nok', een: ['vlag-laag'], twee: [['vlag']], boven: true, hint: 'Tik op de vlag',
          zin1: 'Een vlag op de nok. Hij moet nog omhoog.', zin2: 'Daar wappert hij. Nu is het af.',
          ik: 'Op mijn huis wappert een vlag op de nok.', alt: 'een gele vlag op de nok' },
        { id: 's', naam: 'Een hijsbalk', sub: 'met een ton eraan', een: ['balk'], twee: [['balk-op']], boven: true, hint: 'Tik op de ton',
          zin1: 'Een hijsbalk met een ton. Kan die omhoog?', zin2: 'Hup, de ton gaat omhoog. Zo werkt dat dus.',
          ik: 'Aan mijn huis hangt een hijsbalk, en de ton gaat echt omhoog.', alt: 'een hijsbalk met een ton' },
        { id: 'v', naam: 'Een waakhond', sub: 'bij de voordeur', een: ['hond-deur'], twee: [['hond']], hint: 'Tik op de hond',
          zin1: 'Een hond bij de voordeur. Hij kijkt nog naar binnen.', zin2: 'Hij draait zich om. Hier komt niemand zomaar binnen.',
          ik: 'Voor mijn deur zit een hond die de wacht houdt.', alt: 'een witte hond bij de voordeur' },
        { id: 'e', naam: 'Een torentje', sub: 'op het dak', een: ['toren-kaal'], twee: [['toren']], boven: true, hint: 'Tik op het torentje',
          zin1: 'Een torentje op het dak. Er zit iets in.', zin2: 'Een schatkist vol goud. Zo heeft niemand anders dit huis.',
          ik: 'Op mijn dak staat een torentje met een schatkist vol goud.', alt: 'een torentje met een schatkist vol goud', glans: [[0.34, 0.19], [0.6, 0.16], [0.46, 0.11]] }
      ]
    }
  ];

  var MASCOTTE = (function () {
    var LIJF = '<g class="spg-mas__lijf"><rect x="21.5" y="19" width="29" height="12" rx="2.5" fill="#ffd54f"/><rect x="69.5" y="19" width="29" height="12" rx="2.5" fill="#ffd54f"/>' +
      '<rect x="12" y="28" width="96" height="74" rx="10" fill="#ffc107"/><path d="M20 40v52" stroke="#ffe3a3" stroke-width="5" stroke-linecap="round" fill="none"/>' +
      '<g class="spg-mas__ogen"><ellipse cx="45" cy="60" rx="5.5" ry="7" fill="#1a1a1a" stroke="none"/><ellipse cx="75" cy="60" rx="5.5" ry="7" fill="#1a1a1a" stroke="none"/>' +
      '<circle cx="47" cy="57" r="2" fill="#fff" stroke="none"/><circle cx="77" cy="57" r="2" fill="#fff" stroke="none"/></g>' +
      '<circle cx="34" cy="74" r="5" fill="#ff8a65" opacity=".45" stroke="none"/><circle cx="86" cy="74" r="5" fill="#ff8a65" opacity=".45" stroke="none"/>' +
      '<path d="M50 76 Q60 86 70 76" fill="none" stroke-width="3.5"/></g>';
    function hand(x, y, hoek) {
      return '<g transform="rotate(' + hoek + ' ' + (x + 11) + ' ' + (y + 7) + ')"><rect x="' + x + '" y="' + y + '" width="22" height="14" rx="7" fill="#ffc107"/><path d="M' + (x + 7) + ' ' + (y + 1) + 'v6M' + (x + 13) + ' ' + (y + 1) + 'v6" stroke-width="2" fill="none"/></g>';
    }
    function tand(cx, cy, r, n, kleur) {
      var d = '';
      for (var i = 0; i < n * 2; i++) {
        var a0 = (i / (n * 2)) * Math.PI * 2, a1 = ((i + 1) / (n * 2)) * Math.PI * 2;
        var rr = i % 2 ? r : r + 6;
        d += (i ? 'L' : 'M') + (cx + Math.cos(a0 + 0.08) * rr).toFixed(1) + ' ' + (cy + Math.sin(a0 + 0.08) * rr).toFixed(1) +
          'L' + (cx + Math.cos(a1 - 0.08) * rr).toFixed(1) + ' ' + (cy + Math.sin(a1 - 0.08) * rr).toFixed(1);
      }
      return '<path d="' + d + 'Z" fill="' + kleur + '"/><circle cx="' + cx + '" cy="' + cy + '" r="5" fill="#fff"/>';
    }
    function poppetje(x, y, romp, spiegel) {
      var s = spiegel ? ' transform="translate(' + (2 * x + 22) + ' 0) scale(-1 1)"' : '';
      return '<g' + s + '>' +
        '<rect x="' + (x + 7) + '" y="' + (y - 3) + '" width="8" height="4" rx="1.2" fill="#ffc107"/>' +
        '<rect x="' + (x + 3) + '" y="' + y + '" width="16" height="15" rx="5" fill="#ffc107"/>' +
        '<circle cx="' + (x + 14) + '" cy="' + (y + 6) + '" r="1.6" fill="#1a1a1a" stroke="none"/>' +
        '<path d="M' + (x + 10) + ' ' + (y + 10) + 'q4 3 7 0" fill="none" stroke-width="2"/>' +
        '<path d="M' + (x + 2) + ' ' + (y + 16) + 'h18l3 17h-24z" fill="' + romp + '"/>' +
        '<rect x="' + (x + 1) + '" y="' + (y + 33) + '" width="20" height="13" rx="2" fill="#1a1a1a"/>' +
        '</g>';
    }
    var DELEN = {
      t: {
        box: '-44 -40 210 152',
        voor: '<g transform="rotate(-14 -4 102)"><rect x="-28" y="44" width="12" height="58" rx="2" fill="#17994d"/><path d="M-22 52v8" stroke="#fff" stroke-width="2.5" fill="none"/>' +
          '<rect x="-16" y="36" width="13" height="66" rx="2" fill="#e23744"/><path d="M-9.5 44v10" stroke="#fff" stroke-width="2.5" fill="none"/>' +
          '<rect x="-3" y="48" width="12" height="54" rx="2" fill="#fff"/></g>',
        na: hand(-12, 64, 72) + '<rect x="87" y="78" width="8" height="5" rx="1.5" fill="#e23744" stroke-width="2.5"/><rect x="101" y="78" width="8" height="5" rx="1.5" fill="#e23744" stroke-width="2.5"/><rect x="84" y="82" width="28" height="20" rx="3" fill="#e23744"/><path d="M88 86v12" stroke="#f2808f" stroke-width="3" stroke-linecap="round" fill="none"/>' + hand(96, 88, -48)
      },
      s: {
        box: '-44 -40 210 152',
        voor: '',
        na: tand(124, 82, 17, 8, '#bdbdbd') + hand(6, 91, 28) + hand(97, 74, -14)
      },
      v: {
        box: '-44 -40 210 152',
        voor: '',
        na: poppetje(-16, 56, '#e23744', false) + poppetje(114, 56, '#1e5aa8', true) + '<g transform="translate(14 0)"><path d="M-34 22 h22 a6 6 0 0 1 6 6 v10 a6 6 0 0 1 -6 6 h-4 v7 l-6 -7 h-12 a6 6 0 0 1 -6 -6 v-10 a6 6 0 0 1 6 -6z" fill="#ffe3a3" stroke-width="2.5"/><path d="M-27 33 h12" stroke-width="3" stroke-linecap="round" fill="none"/>' +
          '</g><g transform="translate(-14 0)"><path d="M134 22 h22 a6 6 0 0 1 6 6 v10 a6 6 0 0 1 -6 6 h-12 l-6 7 v-7 h-4 a6 6 0 0 1 -6 -6 v-10 a6 6 0 0 1 6 -6z" fill="#fff" stroke-width="2.5"/>' +
          '<circle cx="139" cy="33" r="2" fill="#1a1a1a" stroke="none"/><circle cx="145" cy="33" r="2" fill="#1a1a1a" stroke="none"/><circle cx="151" cy="33" r="2" fill="#1a1a1a" stroke="none"/></g>' +
          hand(-4, 80, 24) + hand(102, 80, -24)
      },
      e: {
        box: '-44 -40 210 152',
        voor: '',
        na: '<g transform="rotate(-9 60 -6)"><path d="M2 8 L118 8 L92 -26 L28 -26 Z" fill="#e23744"/><path d="M30 -21 L90 -21" stroke="#f2808f" stroke-width="3" stroke-linecap="round" fill="none"/>' +
          '<rect x="0" y="6" width="120" height="10" rx="2.5" fill="#e23744"/></g>' +
          hand(-6, 22, -74) + hand(104, 12, 74)
      }
    };
    return function (type) {
      var d = DELEN[type];
      if (!d) return '';
      return '<svg class="spg-mas spg-bq-mas spg-bq-mas--' + type + '" viewBox="' + d.box + '" aria-hidden="true" focusable="false"><g stroke="#1a1a1a" stroke-width="3" stroke-linejoin="round">' + d.voor + LIJF + d.na + '</g></svg>';
    };
  })();

  var VOLGORDE = ['garage', 'balk', 'vlag', 'toren', 'boef', 'tuin', 'kat', 'hond', 'lantaarn', 'molen', 'postbode', 'boomhut', 'boef-klim'];
  function diepte(naam) {
    var best = 0, lengte = 0;
    VOLGORDE.forEach(function (v, i) {
      if (naam === v || naam.indexOf(v + '-') === 0) {
        if (v.length > lengte) { lengte = v.length; best = i; }
      }
    });
    return 10 + best;
  }

  var $ = function (s, el) { return (el || wortel).querySelector(s); };
  var podium = $('[data-bq-podium]');
  var wereld = $('[data-bq-wereld]');
  var tikknop = $('[data-bq-tik]');
  var tikhint = $('[data-bq-hint]');
  var paneel = $('[data-bq-paneel]');
  var intro = $('[data-bq-intro]');
  var spel = $('[data-bq-spel]');
  var uitslag = $('[data-bq-uitslag]');
  var rondeEl = $('[data-bq-ronde]');
  var vraagEl = $('[data-bq-vraag]');
  var zinEl = $('[data-bq-zin]');
  var tegelsEl = $('[data-bq-tegels]');
  var actiesEl = $('[data-bq-acties]');
  var stippen = $('[data-bq-stippen]');

  function meld(naam, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('spg_bouwerquiz_' + naam, data || {});
      }
    } catch (e) {}
  }

  var toets = false;
  var kaderNu = { x: 0, y: 0, z: 1 };
  var imgs = {};
  var hoogBasis = false;

  function sleutel(naam, hoog) {
    if (hoog && BEELD[naam + '@hoog']) return naam + '@hoog';
    return naam;
  }

  function laag(naam) {
    if (imgs[naam]) return imgs[naam];
    var b = BEELD[naam];
    if (!b) return null;
    var voor = naam === 'basis' && wereld.querySelector('[data-bq-basis-voor]');
    if (voor) {
      voor.style.zIndex = 1;
      imgs[naam] = voor;
      return voor;
    }
    var img = new Image();
    img.alt = '';
    img.decoding = 'async';
    img.draggable = false;
    img.className = 'spg-bq-laag';
    img.style.left = (b.x * 100) + '%';
    img.style.top = (b.y * 100) + '%';
    img.style.width = (b.w * 100) + '%';
    img.style.height = (b.h * 100) + '%';
    img.style.zIndex = b.z || diepte(naam.split('@')[0]);
    img.src = b.u;
    wereld.appendChild(img);
    imgs[naam] = img;
    return img;
  }

  function klaar(img) {
    if (!img) return Promise.resolve();
    if (img.complete && img.naturalWidth) return Promise.resolve();
    if (img.decode) return img.decode().catch(function () {});
    return new Promise(function (r) { img.onload = img.onerror = r; });
  }

  function voorlaad(namen) {
    namen.forEach(function (n) { var b = BEELD[n]; if (b) { var i = new Image(); i.src = b.u; } });
  }

  function toon(naam, aan, effect) {
    var img = laag(naam);
    if (!img) return;
    img.classList.remove('is-klik', 'is-uit');
    if (aan) {
      img.classList.add('is-aan');
      if (effect && !RUST) { void img.offsetWidth; img.classList.add('is-klik'); }
    } else {
      img.classList.remove('is-aan');
    }
  }

  var keuzes = [null, null, null];
  var ronde = 0;
  var fase = 0;
  var bezig = false;
  var naBezig = null;

  function vrij() {
    bezig = false;
    var f = naBezig;
    naBezig = null;
    if (f) f();
  }
  var draaiTimer = null;
  var deelCode = null;

  function hoogNu() { return keuzes[0] === 'e'; }

  function keuzeVan(r, id) {
    return RONDES[r].keuzes.filter(function (k) { return k.id === id; })[0];
  }

  function zichtbaar() {
    var lijst = [hoogNu() ? 'hoog' : 'basis'];
    var kat = 'kat';
    for (var r = 0; r < 3; r++) {
      var id = keuzes[r];
      if (!id) continue;
      var k = keuzeVan(r, id);
      var stap = (r < ronde || fase === 2 || r < 0) ? 2 : 1;
      if (r === ronde && fase === 1) stap = 1;
      if (k.verdieping) continue;
      var namen = stap === 2 && k.twee ? k.twee[k.twee.length - 1] : k.een;
      namen.forEach(function (n) { lijst.push(sleutel(n, hoogNu())); });
      if (k.kat && stap === 2) kat = k.kat;
    }
    lijst.push(sleutel(kat, hoogNu()));
    return lijst;
  }

  function binnen(r, k) {
    return !r || (r[0] >= k.x && r[1] >= k.y && r[2] <= k.x + k.z && r[3] <= k.y + (k.h || k.z));
  }

  function wachtCamera() {
    return new Promise(function (klaar) {
      var t = setTimeout(af, 1100);
      function af() { clearTimeout(t); wereld.removeEventListener('transitionend', eind); klaar(); }
      function eind(e) { if (e.target === wereld) af(); }
      wereld.addEventListener('transitionend', eind);
    });
  }

  function teken(effectVoor) {
    var lijst = zichtbaar();
    var oud = kaderNu;
    Object.keys(imgs).forEach(function (n) {
      if (lijst.indexOf(n) < 0 && !imgs[n].classList.contains('is-anim')) toon(n, false);
    });
    kader(lijst);
    beschrijf();
    var nieuw = effectVoor || [];
    var later = !RUST && nieuw.some(function (n) { return !binnen(rect(n), oud); });
    lijst.forEach(function (n) { if (!later || nieuw.indexOf(n) < 0) toon(n, true, nieuw.indexOf(n) >= 0); });
    if (!later) return Promise.resolve();
    return wachtCamera().then(function () {
      if (zichtbaar().join() !== lijst.join()) return;
      nieuw.forEach(function (n) { toon(n, true, true); });
    });
  }

  function rect(n) {
    if (typeof n !== 'string') return n;
    var b = BEELD[n];
    if (!b) return null;
    if (n === 'basis' || n === 'hoog') return b.i;
    return b.a || b.i || [b.x, b.y, b.x + b.w, b.y + b.h];
  }

  function omhoog(n, dy) {
    var r = rect(n);
    return r ? [r[0], r[1] - dy, r[2], r[3]] : null;
  }

  function verhouding() {
    var w = podium.clientWidth, h = podium.clientHeight;
    return w && h ? Math.max(1, w / h) : 1;
  }

  function vak(lijst, marge) {
    var box = null;
    lijst.forEach(function (n) {
      var r = rect(n);
      if (!r) return;
      box = box ? [Math.min(box[0], r[0]), Math.min(box[1], r[1]), Math.max(box[2], r[2]), Math.max(box[3], r[3])] : r.slice();
    });
    if (!box) return null;
    var a = verhouding();
    var bw = box[2] - box[0], bh = box[3] - box[1];
    var zw = Math.max(bw + 2 * marge, (bh + 2 * marge) * a, 0.5);
    if (zw > 1) zw = Math.max(1, Math.min(zw, Math.max(bw + marge, (bh + marge) * a)));
    zw = Math.min(zw, 1.45);
    var zh = zw / a;
    var cx = (box[0] + box[2]) / 2, cy = (box[1] + box[3]) / 2;
    function plaats(c, z) { return z <= 1 ? Math.min(Math.max(c - z / 2, 0), 1 - z) : Math.min(Math.max(c - z / 2, 1 - z), 0); }
    return {
      x: plaats(cx, zw),
      y: plaats(cy, zh),
      z: zw,
      h: zh
    };
  }

  function groei(a, b, n) {
    var c = (a + b) / 2;
    a = c - n / 2; b = c + n / 2;
    if (a < 0) { b -= a; a = 0; }
    if (b > 1) { a -= b - 1; b = 1; }
    return [Math.max(0, a), Math.min(1, b)];
  }

  function storyVak(lijst) {
    var box = null;
    lijst.forEach(function (n) {
      var r = rect(n);
      if (!r) return;
      box = box ? [Math.min(box[0], r[0]), Math.min(box[1], r[1]), Math.max(box[2], r[2]), Math.max(box[3], r[3])] : r.slice();
    });
    if (!box) return [0, 0, 1, 1];
    var m = 0.05;
    var r = [Math.max(0, box[0] - m), Math.max(0, box[1] - m), Math.min(1, box[2] + m), Math.min(1, box[3] + m)];
    var w = r[2] - r[0], h = r[3] - r[1];
    if (h < w * 0.62) { var y = groei(r[1], r[3], w * 0.62); r[1] = y[0]; r[3] = y[1]; }
    return r;
  }

  var laatsteKader = null;

  function kader(lijst) {
    laatsteKader = lijst;
    var k = vak(lijst, 0.04);
    if (!k) return;
    kaderNu = k;
    wereld.classList.toggle('is-ver', k.z > 1.001 || k.h > 1.001);
    wereld.style.transform = 'scale(' + (1 / k.z).toFixed(4) + ') translate(' + (-k.x * 100).toFixed(3) + '%, ' + (-k.y * 100).toFixed(3) + '%)';
  }

  function beschrijf() {
    var delen = [];
    for (var r = 0; r < 3; r++) if (keuzes[r]) delen.push(keuzeVan(r, keuzes[r]).alt);
    var tekst = 'Een wit huisje met een rood dak en een kat bij het pad';
    if (delen.length) tekst += ', met ' + delen.join(', ');
    wereld.setAttribute('aria-label', tekst + '.');
  }

  function wacht(ms) { return new Promise(function (r) { setTimeout(r, RUST ? 0 : ms); }); }

  function frames(reeks, tussen) {
    var p = Promise.resolve();
    var vorige = null;
    reeks.forEach(function (namen) {
      p = p.then(function () {
        var nieuw = namen.map(function (n) { return sleutel(n, hoogNu()); });
        return Promise.all(nieuw.map(function (n) { return klaar(laag(n)); })).then(function () {
          nieuw.forEach(function (n) { toon(n, true); });
          if (vorige) vorige.forEach(function (n) { if (nieuw.indexOf(n) < 0) toon(n, false); });
          vorige = nieuw;
          return wacht(tussen);
        });
      });
    });
    return p.then(function () { return vorige; });
  }

  function glans(naam, punten) {
    if (RUST || !punten) return;
    var r = rect(naam);
    if (!r) return;
    punten.forEach(function (pt, i) {
      var g = document.createElement('span');
      g.className = 'spg-bq-glans';
      g.setAttribute('aria-hidden', 'true');
      g.style.left = ((r[0] + (r[2] - r[0]) * pt[0]) * 100).toFixed(2) + '%';
      g.style.top = ((r[1] + (r[3] - r[1]) * pt[1]) * 100).toFixed(2) + '%';
      g.style.animationDelay = (i * 0.35).toFixed(2) + 's';
      g.addEventListener('animationend', function () { g.remove(); });
      wereld.appendChild(g);
    });
  }

  function stopDraai() { if (draaiTimer) { clearTimeout(draaiTimer); draaiTimer = null; } }

  function uitdraai() {
    stopDraai();
    if (RUST) return;
    var n = ['molen-0', 'molen-1', 'molen-2'].map(function (x) { return sleutel(x, hoogNu()); });
    var tijden = [100, 110, 125, 140, 160, 185, 215, 255, 310];
    var i = 0;
    (function volgende(stap) {
      if (stap >= tijden.length) { draaiTimer = null; return; }
      draaiTimer = setTimeout(function () {
        i = (i + 1) % 3;
        n.forEach(function (x, j) { toon(x, j === i); });
        volgende(stap + 1);
      }, tijden[stap]);
    })(0);
  }

  var VERD = { dy: (BEELD.dak && BEELD.dak.dy) || 0.17125 };

  function zetVerd(stand) {
    ['romp', 'verd', 'dak'].forEach(function (n) { laag(n); imgs[n].classList.add('is-anim'); });
    var dak = imgs.dak, verd = imgs.verd, romp = imgs.romp;
    var h = VERD.dy * 100 / (BEELD.dak.h || 1);
    var hv = VERD.dy * 100 / (BEELD.verd.h || 1);
    var lift = 0.045 * 100 / (BEELD.dak.h || 1);
    if (stand === 'uit') {
      [dak, verd, romp].forEach(function (i) { i.classList.remove('is-aan', 'is-veer', 'is-glijd'); i.style.transform = ''; });
      return;
    }
    romp.classList.add('is-aan');
    dak.classList.add('is-aan');
    if (stand === 'dicht') { dak.style.transform = 'translateY(' + h + '%)'; verd.classList.remove('is-aan'); }
    if (stand === 'open') { dak.classList.add('is-glijd'); dak.style.transform = 'translateY(' + (-lift) + '%)'; verd.classList.remove('is-aan'); verd.style.transform = 'translateY(' + (-hv * 1.4) + '%)'; }
    if (stand === 'verd') { verd.classList.add('is-aan', 'is-veer'); verd.style.transform = 'translateY(0)'; }
    if (stand === 'zak') { dak.classList.remove('is-glijd'); dak.classList.add('is-veer'); dak.style.transform = 'translateY(0)'; }
  }

  function verdiepingStap1() {
    var namen = ['romp', 'verd', 'dak', 'hoog'].concat(BEELD['kat@hoog'] ? ['kat@hoog'] : []);
    return Promise.all(namen.map(function (n) { return klaar(laag(n)); })).then(function () {
      zetVerd('dicht');
      toon('basis', false);
      void imgs.dak.offsetWidth;
      kader(['hoog', omhoog('dak', 0.045)]);
      return wacht(60);
    }).then(function () {
      zetVerd('open');
      return wacht(650);
    });
  }

  function verdiepingStap2() {
    zetVerd('verd');
    podium.classList.add('is-schok');
    return wacht(520).then(function () {
      podium.classList.remove('is-schok');
      zetVerd('zak');
      return wacht(480);
    }).then(function () {
      podium.classList.add('is-schok');
      toon('hoog', true);
      return wacht(140);
    }).then(function () {
      podium.classList.remove('is-schok');
      zetVerd('uit');
    });
  }

  function verdiepingTerug() {
    zetVerd('uit');
    toon('hoog', false);
    toon('basis', true);
  }

  function plekHint(doelen) {
    var W = podium.clientWidth || 340, H = podium.clientHeight || 340;
    var hw = tikhint.offsetWidth || 180, hh = tikhint.offsetHeight || 40;
    var k = kaderNu, box = null;
    doelen.forEach(function (n) {
      var r = rect(n);
      if (!r) return;
      box = box ? [Math.min(box[0], r[0]), Math.min(box[1], r[1]), Math.max(box[2], r[2]), Math.max(box[3], r[3])] : r.slice();
    });
    var m = 10, gat = 12, pijl = '';
    var x0 = box ? (box[0] - k.x) / k.z * W : W / 2, x1 = box ? (box[2] - k.x) / k.z * W : W / 2;
    var y0 = box ? (box[1] - k.y) / (k.h || k.z) * H : H / 2, y1 = box ? (box[3] - k.y) / (k.h || k.z) * H : H / 2;
    var doelX = Math.min(Math.max((x0 + x1) / 2, m), W - m);
    var x = Math.min(Math.max(doelX - hw / 2, m), W - hw - m);
    var y;
    if (y1 + gat + hh <= H - m) { y = y1 + gat; pijl = 'op'; }
    else if (y0 - gat - hh >= m) { y = y0 - gat - hh; pijl = 'neer'; }
    else { y = Math.min(Math.max(y1 - hh, m), H - hh - m); }
    tikknop.dataset.plek = 'bij';
    tikhint.style.left = (x / W * 100).toFixed(2) + '%';
    tikhint.style.top = (y / H * 100).toFixed(2) + '%';
    tikhint.style.setProperty('--pijl-x', Math.round(Math.min(Math.max(doelX - x, 16), hw - 16)) + 'px');
    if (pijl) tikhint.dataset.pijl = pijl; else delete tikhint.dataset.pijl;
  }

  function zetTik(aan, tekst) {
    tikknop.hidden = !aan;
    if (aan) {
      tikhint.textContent = tekst;
      tikknop.setAttribute('aria-label', tekst);
    }
  }

  function zetActies(aan) {
    actiesEl.classList.toggle('is-uit', !aan);
    actiesEl.inert = !aan;
    if (aan) actiesEl.removeAttribute('aria-hidden'); else actiesEl.setAttribute('aria-hidden', 'true');
  }

  function zetZin(t) {
    zinEl.classList.remove('is-nieuw');
    zinEl.textContent = t;
    spel.classList.toggle('heeft-zin', !!t);
    if (t && !RUST) { void zinEl.offsetWidth; zinEl.classList.add('is-nieuw'); }
  }

  function tekenTegels() {
    tegelsEl.innerHTML = '';
    RONDES[ronde].keuzes.forEach(function (k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'spg-bq-tegel';
      b.dataset.keuze = k.id;
      b.setAttribute('aria-pressed', keuzes[ronde] === k.id ? 'true' : 'false');
      var n = document.createElement('b'); n.textContent = k.naam;
      var s = document.createElement('span'); s.textContent = k.sub;
      var nop = document.createElement('span');
      nop.className = 'spg-bq-noppen';
      nop.setAttribute('aria-hidden', 'true');
      nop.innerHTML = '<i></i><i></i><i></i><i></i>';
      b.appendChild(nop); b.appendChild(n); b.appendChild(s);
      tegelsEl.appendChild(b);
    });
  }

  function zetRonde() {
    rondeEl.textContent = 'Ronde ' + (ronde + 1) + ' van 3';
    vraagEl.textContent = RONDES[ronde].vraag;
    stippen.querySelectorAll('i').forEach(function (i, n) {
      i.classList.toggle('is-af', n < ronde);
      i.classList.toggle('is-nu', n === ronde);
    });
    tekenTegels();
    zetZin('');
    zetActies(false);
    zetTik(false);
    if (!RUST) {
      spel.classList.remove('is-wissel'); void spel.offsetWidth; spel.classList.add('is-wissel');
    }
  }

  var wisselNr = 0;

  function ruimOp(r) {
    wisselNr += 1;
    stopDraai();
    wereld.querySelectorAll('.spg-bq-glans').forEach(function (g) { g.remove(); });
    if (r === 0 && keuzes[0] === 'e') verdiepingTerug();
    keuzes[r] = null;
    fase = 0;
    var lijst = zichtbaar();
    Object.keys(imgs).forEach(function (n) { toon(n, lijst.indexOf(n) >= 0); });
  }

  function kies(id) {
    if (bezig) { naBezig = function () { kies(id); }; return; }
    var k = keuzeVan(ronde, id);
    var r = ronde;
    bezig = true;
    var p = Promise.resolve();
    ruimOp(r);
    keuzes[r] = id;
    fase = 1;
    tegelsEl.querySelectorAll('.spg-bq-tegel').forEach(function (t) { t.setAttribute('aria-pressed', t.dataset.keuze === id ? 'true' : 'false'); });
    meld('keuze', { ronde: r + 1, keuze: k.naam, type: id });
    if (k.verdieping) {
      p = verdiepingStap1();
    } else {
      var nieuw = k.een.map(function (n) { return sleutel(n, hoogNu()); });
      p = Promise.all(nieuw.map(function (n) { return klaar(laag(n)); })).then(function () { return teken(nieuw); });
    }
    p.then(function () {
      zetZin(k.zin1);
      zetTik(true, k.hint);
      plekHint(k.verdieping ? [omhoog('dak', 0.045)] : k.een.map(function (n) { return sleutel(n, hoogNu()); }));
      houdTekst();
      zetActies(true);
      if (toets) tikknop.focus({ preventScroll: true });
      if (r === 0) voorlaad(laadLijst(1));
      vrij();
    });
  }

  function tik() {
    if (bezig || fase !== 1) return;
    var k = keuzeVan(ronde, keuzes[ronde]);
    bezig = true;
    zetTik(false);
    var p;
    if (k.verdieping) {
      p = verdiepingStap2().then(function () { fase = 2; teken(); });
    } else {
      var reeks = k.twee;
      if (k.kat) {
        reeks = reeks.slice();
        reeks[0] = reeks[0].concat([]);
      }
      if (RUST) reeks = [reeks[reeks.length - 1]];
      var alle = [].concat.apply([], reeks).map(function (n) { return sleutel(n, hoogNu()); });
      var oud = kaderNu;
      kader(zichtbaar().concat(alle));
      var camera = (!RUST && alle.some(function (n) { return !binnen(rect(n), oud); })) ? wachtCamera() : Promise.resolve();
      p = camera.then(function () { return frames(reeks, k.draai ? 95 : 130); }).then(function () {
        fase = 2;
        teken();
        if (k.draai) uitdraai();
        if (k.glans) glans(sleutel(k.twee[0][0], hoogNu()), k.glans);
      });
      if (k.kat) {
        var nr = wisselNr;
        camera.then(function () { return wacht(260); }).then(function () { if (nr !== wisselNr) return; toon('kat', false); toon(k.kat, true); });
      }
    }
    p.then(function () {
      zetZin(k.zin2);
      zetActies(true);
      houdTekst();
      if (!naBezig && (toets || document.activeElement === document.body)) $('[data-bq-houd]').focus({ preventScroll: true });
      vrij();
    });
  }

  function opnieuwRonde() {
    if (bezig) { naBezig = opnieuwRonde; return; }
    var r = ronde;
    ruimOp(r);
    teken();
    tegelsEl.querySelectorAll('.spg-bq-tegel').forEach(function (t) { t.setAttribute('aria-pressed', 'false'); });
    zetZin('');
    zetActies(false);
    zetTik(false);
    meld('opnieuw', { ronde: r + 1 });
    var eerste = tegelsEl.querySelector('.spg-bq-tegel');
    if (eerste) eerste.focus({ preventScroll: true });
  }

  function houdTekst() {
    $('[data-bq-houd-tekst]').textContent = ronde < 2 ? 'Bouw verder' : 'Bekijk mijn uitslag';
  }

  function houd() {
    if (bezig) { naBezig = houd; return; }
    if (!keuzes[ronde]) return;
    stopDraai();
    if (fase === 1) {
      var kn = keuzeVan(ronde, keuzes[ronde]);
      if (kn.verdieping) { zetVerd('uit'); toon('basis', false); }
      fase = 2;
      zetTik(false);
      meld('zonder_tik', { ronde: ronde + 1, type: keuzes[ronde] });
    }
    if (ronde < 2) {
      ronde += 1;
      fase = 0;
      zetRonde();
      teken();
      voorlaad(laadLijst(ronde));
      vraagEl.focus({ preventScroll: true });
      if (window.innerWidth < 990 && getComputedStyle(spel).position !== 'fixed') {
        var top = wortel.getBoundingClientRect().top + window.scrollY - (parseInt(wortel.style.getPropertyValue('--spg-bq-boven'), 10) || 0);
        if (Math.abs(window.scrollY - top) > 40) window.scrollTo({ top: top, behavior: RUST ? 'auto' : 'smooth' });
      }
    } else {
      fase = 2;
      ronde = 3;
      toonUitslag(keuzes.join(''), false);
    }
  }

  function laadLijst(r) {
    var lijst = [];
    if (r >= RONDES.length) return lijst;
    RONDES[r].keuzes.forEach(function (k) {
      (k.een || []).concat.apply(k.een || [], k.twee || []).forEach(function (n) { lijst.push(sleutel(n, hoogNu())); });
    });
    return lijst;
  }

  function winnaar(code) {
    var tel = {};
    code.split('').forEach(function (c) { tel[c] = (tel[c] || 0) + 1; });
    var max = Math.max.apply(null, Object.keys(tel).map(function (k) { return tel[k]; }));
    var top = Object.keys(tel).filter(function (k) { return tel[k] === max; });
    return top.indexOf(code[0]) >= 0 ? code[0] : top[0];
  }

  function ikZin(code, type) {
    for (var r = 0; r < 3; r++) if (code[r] === type) return keuzeVan(r, code[r]).ik;
    return '';
  }

  function deelLink(code) {
    var u = new URL(location.href);
    u.hash = '';
    u.searchParams.set('bq', code);
    return u.toString();
  }

  function geld(c) {
    try { return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(c / 100); } catch (e) { return '€ ' + (c / 100).toFixed(2).replace('.', ','); }
  }

  function inMandje(s, type, knop, tekst) {
    knop.disabled = true; knop.setAttribute('aria-busy', 'true'); tekst.textContent = 'Even geduld';
    var wortelPad = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var secties = Array.prototype.map.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) { return el.dataset.sectionId; }).join(',');
    var E = null, uitgesteld = null;
    import('@shopify/events').then(function (m) { return m.CartLinesUpdateEvent; }, function () { return null; }).then(function (ev) {
      E = ev;
      if (E) { uitgesteld = E.createPromise(); document.dispatchEvent(new E({ action: 'add', context: 'product', lines: [{ merchandiseId: String(s.v), quantity: 1 }], promise: uitgesteld.promise })); }
      return fetch(wortelPad + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: s.v, quantity: 1 }], sections: secties || undefined })
      }).then(function (r) { return r.ok ? r.json() : null; }, function () { return null; });
    }).then(function (antwoord) {
      knop.removeAttribute('aria-busy');
      if (antwoord) {
        knop.classList.add('is-in'); tekst.textContent = 'In je winkelwagen';
        meld('toegevoegd', { handle: s.h, type: type, waarde: s.p / 100, doelgroep: voorWie === 'k' ? 'kind' : 'mezelf' });
      } else { knop.disabled = false; tekst.textContent = 'Lukt niet, probeer opnieuw'; }
      if (!uitgesteld) return;
      return fetch(wortelPad + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        uitgesteld.resolve({ cart: E.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'spg-bouwerquiz', itemCount: antwoord ? 1 : 0, sections: antwoord && antwoord.sections, didError: !antwoord } });
      }).catch(function () { uitgesteld.resolve({ cart: null, detail: { didError: true } }); });
    });
  }

  var voorWie = 'm', setsType = null;

  function zetVoor(g, door) {
    voorWie = g === 'k' ? 'k' : 'm';
    Array.prototype.forEach.call(document.querySelectorAll('[data-bq-voor-keuze]'), function (b) { b.setAttribute('aria-pressed', String(b.dataset.bqVoorKeuze === voorWie)); });
    if (setsType) tekenSets(setsType);
    if (door) meld('doelgroep', { doelgroep: voorWie === 'k' ? 'kind' : 'mezelf', type: setsType });
  }

  var GEHAALD = {}, tekenNr = 0;

  function haalGroep(type, g) {
    var sleutel = type + g;
    if (GEHAALD[sleutel]) return GEHAALD[sleutel];
    var regels = (SETS[type] || {})[g] || [];
    var basis = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    GEHAALD[sleutel] = Promise.all(regels.map(function (r) {
      return fetch(basis + 'products/' + encodeURIComponent(r.h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (a) { return a.ok ? a.json() : null; })
        .then(function (p) {
          if (!p || !p.available) return null;
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return null;
          var img = p.featured_image || null;
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          if (img) img += (img.indexOf('?') >= 0 ? '&' : '?') + 'width=400';
          return { h: r.h, l: r.l, zin: r.zin, v: v.id, t: p.title, p: v.price, url: p.url || (basis + 'products/' + p.handle), img: img };
        })
        .catch(function () { return null; });
    })).then(function (lijst) {
      var gezien = {};
      return lijst.filter(function (s) { if (!s || gezien[s.h]) return false; gezien[s.h] = true; return true; }).slice(0, 3);
    });
    return GEHAALD[sleutel];
  }

  function tekenSets(type) {
    setsType = type;
    var nr = ++tekenNr;
    var wie = voorWie;
    var lijst = $('[data-bq-sets]');
    lijst.setAttribute('aria-busy', 'true');
    Promise.all([haalGroep(type, wie), haalGroep(type, wie === 'k' ? 'm' : 'k')]).then(function (r) {
      if (nr !== tekenNr) return;
      lijst.removeAttribute('aria-busy');
      vulSets(type, r[0], r[0].length + r[1].length > 0);
    });
  }

  function vulSets(type, sets, ergens) {
    var lijst = $('[data-bq-sets]');
    var leeg = $('[data-bq-sets-leeg]');
    var meer = $('[data-bq-meer]');
    var voor = $('[data-bq-voor]');
    lijst.innerHTML = '';
    if (voor) voor.hidden = !ergens;
    leeg.hidden = sets.length > 0;
    lijst.hidden = sets.length === 0;
    if (meer) meer.hidden = sets.length === 0;
    var gids = $('[data-bq-gids]'), gidsVr = $('[data-bq-gids-voorraad]');
    if (gids) gids.hidden = sets.length === 0;
    if (gidsVr) gidsVr.hidden = !sets.length || !sets.every(function (s) { return s.v; });
    sets.forEach(function (s) {
      var kaart = document.createElement('div');
      kaart.className = 'spg-bq-set';
      var klik = function () { meld('set_klik', { handle: s.h, type: type, doelgroep: voorWie === 'k' ? 'kind' : 'mezelf' }); };
      var fig = document.createElement('a'); fig.className = 'spg-bq-set__foto'; fig.href = s.url; fig.tabIndex = -1; fig.setAttribute('aria-hidden', 'true');
      fig.addEventListener('click', klik);
      if (s.img) { var im = document.createElement('img'); im.src = s.img; im.alt = ''; im.loading = 'lazy'; im.width = 400; im.height = 400; fig.appendChild(im); }
      var tekst = document.createElement('span'); tekst.className = 'spg-bq-set__tekst';
      var t = document.createElement('a'); t.className = 'spg-bq-set__naam'; t.href = s.url; t.textContent = s.t;
      t.addEventListener('click', klik);
      tekst.appendChild(t);
      if (s.l) { var lf = document.createElement('span'); lf.className = 'spg-bq-set__leeftijd'; lf.textContent = s.l; lf.setAttribute('aria-label', 'Leeftijd: ' + s.l); }
      if (s.zin) { var z = document.createElement('span'); z.className = 'spg-bq-set__zin'; z.textContent = s.zin; tekst.appendChild(z); }
      var voet = document.createElement('span'); voet.className = 'spg-bq-set__voet';
      var prijs = document.createElement('span'); prijs.className = 'spg-bq-set__prijs'; prijs.textContent = geld(s.p);
      var vr = document.createElement('span'); vr.className = 'spg-bq-set__voorraad'; vr.textContent = 'Op voorraad';
      voet.appendChild(prijs); voet.appendChild(vr); if (lf) voet.appendChild(lf);
      tekst.appendChild(voet);
      if (s.v) {
        var knop = document.createElement('button'); knop.type = 'button'; knop.className = 'spg-bq-knop spg-bq-set__mand';
        knop.setAttribute('aria-label', 'Leg ' + s.t + ' in je winkelwagen');
        var kt = document.createElement('span'); kt.textContent = 'In winkelwagen';
        knop.appendChild(kt);
        knop.addEventListener('click', function () { inMandje(s, type, knop, kt); });
        tekst.appendChild(knop);
      }
      kaart.appendChild(fig); kaart.appendChild(tekst);
      lijst.appendChild(kaart);
    });
  }

  function toonUitslag(code, gedeeld) {
    var type = winnaar(code);
    var T = TYPES[type];
    deelCode = code;
    stopDraai();
    keuzes = code.split('');
    ronde = 3; fase = 2;
    wortel.classList.add('is-uitslag');
    wortel.classList.toggle('is-gedeeld', !!gedeeld);
    intro.hidden = true;
    spel.hidden = true;
    uitslag.hidden = false;
    zetTik(false);
    $('[data-bq-uitslag-boven]').textContent = gedeeld ? 'Iemand bouwde dit huisje' : 'Jouw uitslag';
    $('[data-bq-uitslag-kop]').textContent = (gedeeld ? 'Dit is ' : 'Jij bent ') + T.naam + '.';
    $('[data-bq-uitslag-type]').textContent = T.zin;
    var mas = $('[data-bq-mascotte]');
    if (mas) mas.innerHTML = MASCOTTE(type);
    $('[data-bq-uitslag-ik]').textContent = ikZin(code, type);
    $('[data-bq-deelblok]').hidden = !!gedeeld;
    $('[data-bq-jij]').hidden = !gedeeld;
    tekenSets(type);
    var alles = [];
    for (var r = 0; r < 3; r++) {
      var k = keuzeVan(r, code[r]);
      if (k.verdieping) continue;
      (k.twee ? k.twee[k.twee.length - 1] : k.een).forEach(function (n) { alles.push(sleutel(n, type === 'x' ? false : code[0] === 'e')); });
    }
    Promise.all(alles.concat([code[0] === 'e' ? 'hoog' : 'basis']).map(function (n) { return klaar(laag(n)); })).then(function () {
      if (code[0] === 'e') { toon('basis', false); toon('hoog', true); }
      teken();
    });
    meld('uitslag', { type: T.kop, keuzes: code, via: gedeeld ? 'deellink' : 'spel' });
    var kop = $('[data-bq-uitslag-kop]');
    kop.focus({ preventScroll: true });
    if (!gedeeld) {
      try { history.replaceState(null, '', deelLink(code)); } catch (e) {}
    }
    var top = wortel.getBoundingClientRect().top + window.scrollY - 8 - (parseInt(wortel.style.getPropertyValue('--spg-bq-boven'), 10) || 0);
    if (window.scrollY > top + 20 || gedeeld) window.scrollTo({ top: Math.max(0, top), behavior: RUST ? 'auto' : 'smooth' });
  }

  function status(t) {
    var s = $('[data-bq-status]');
    s.textContent = t;
  }

  function deelHandmatig(link) {
    var s = $('[data-bq-status]');
    var veld = $('[data-bq-deellink]');
    if (!veld) {
      veld = document.createElement('input');
      veld.type = 'text';
      veld.readOnly = true;
      veld.className = 'spg-bq-deellink';
      veld.setAttribute('data-bq-deellink', '');
      veld.setAttribute('aria-label', 'Link naar jouw uitslag');
      veld.addEventListener('focus', function () { veld.select(); });
      s.parentNode.insertBefore(veld, s.nextSibling);
    }
    veld.value = link;
    veld.hidden = false;
    status('Kopieer deze link en stuur hem door:');
    veld.focus({ preventScroll: true });
    veld.select();
    meld('deel', { methode: 'handmatig' });
  }

  function deelKlembord(link) {
    var lukt = navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(link) : Promise.reject();
    lukt.then(function () {
      status('Link gekopieerd');
      meld('deel', { methode: 'klembord' });
    }, function () { deelHandmatig(link); });
  }

  function deel() {
    var code = deelCode;
    var T = TYPES[winnaar(code)];
    var link = deelLink(code);
    var tekst = 'Ik ben ' + T.naam + '. Wat voor LEGO-bouwer ben jij?';
    var veld = $('[data-bq-deellink]');
    if (veld) veld.hidden = true;
    status('');
    var data = { title: 'Wat voor LEGO-bouwer ben jij?', text: tekst, url: link };
    if (navigator.share && (!navigator.canShare || navigator.canShare(data))) {
      navigator.share(data).then(function () { meld('deel', { methode: 'share' }); }, function (e) {
        if (e && e.name === 'AbortError') return;
        deelKlembord(link);
      });
    } else {
      deelKlembord(link);
    }
  }

  function laadImg(src) {
    return new Promise(function (ok, fout) {
      var i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = function () { ok(i); };
      i.onerror = fout;
      i.src = src;
    });
  }

  function rondRect(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function regels(ctx, tekst, max) {
    var woorden = tekst.split(' '), uit = [], nu = '';
    woorden.forEach(function (w) {
      var t = nu ? nu + ' ' + w : w;
      if (ctx.measureText(t).width > max && nu) { uit.push(nu); nu = w; } else nu = t;
    });
    if (nu) uit.push(nu);
    return uit;
  }

  function story() {
    var code = deelCode;
    var type = winnaar(code);
    var T = TYPES[type];
    var knop = $('[data-bq-story]');
    knop.disabled = true;
    status('Je afbeelding wordt gemaakt...');
    var namen = zichtbaar().filter(function (n) { return BEELD[n]; });
    namen.sort(function (a, b) { return (imgs[a] ? +imgs[a].style.zIndex || 0 : 0) - (imgs[b] ? +imgs[b].style.zIndex || 0 : 0); });
    var kop = getComputedStyle($('[data-bq-uitslag-kop]')).fontFamily;
    var body = getComputedStyle(wortel).fontFamily;
    var fontsKlaar = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    var masImg = null;
    var masSvg = MASCOTTE(type).replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" width="420" height="304" ');
    var masP = laadImg('data:image/svg+xml;charset=utf-8,' + encodeURIComponent(masSvg)).then(function (i) { masImg = i; }, function () {});
    fontsKlaar.then(function () {
      return Promise.all(namen.map(function (n) { return laadImg(BEELD[n].u).then(function (i) { return { n: n, i: i }; }); }).concat([masP])).then(function (r) { return r.slice(0, namen.length); });
    }).then(function (lagen) {
      var c = document.createElement('canvas');
      c.width = 1080; c.height = 1920;
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#fbf8f1';
      ctx.fillRect(0, 0, 1080, 1920);
      ctx.fillStyle = 'rgba(255,193,7,0.28)';
      for (var y = 24; y < 520; y += 48) for (var x = 24; x < 1080; x += 48) {
        ctx.globalAlpha = Math.max(0, 1 - y / 520);
        ctx.beginPath(); ctx.arc(x, y, 12, 0, Math.PI * 2); ctx.fill();
      }
      ctx.globalAlpha = 1;
      ctx.fillStyle = '#e23744';
      ctx.font = '700 34px ' + body;
      ctx.textBaseline = 'alphabetic';
      ctx.fillText('WAT VOOR BOUWER BEN JIJ?', 90, 190);
      ctx.fillStyle = '#1a1a1a';
      ctx.font = '400 84px ' + kop;
      var r1 = regels(ctx, 'Ik ben ' + T.naam + '.', 900);
      r1.forEach(function (t, i) { ctx.fillText(t, 90, 300 + i * 96); });
      var sv = storyVak(namen);
      var kaart = 900;
      var verh = (sv[3] - sv[1]) / (sv[2] - sv[0]);
      var kaartW = Math.round(verh > 1 ? kaart / verh : kaart);
      var kaartH = Math.round(Math.min(1, verh) * kaart);
      var xKaart = Math.round(540 - kaartW / 2);
      var yKaart = 300 + r1.length * 96 + 10 + Math.round((kaart - kaartH) / 2);
      ctx.fillStyle = '#1a1a1a';
      rondRect(ctx, xKaart, yKaart + 10, kaartW, kaartH, 44); ctx.fill();
      ctx.fillStyle = '#ffffff';
      rondRect(ctx, xKaart, yKaart, kaartW, kaartH, 44); ctx.fill();
      ctx.lineWidth = 5; ctx.strokeStyle = '#1a1a1a'; ctx.stroke();
      ctx.save();
      rondRect(ctx, xKaart + 2, yKaart + 2, kaartW - 4, kaartH - 4, 42); ctx.clip();
      var g = ctx.createRadialGradient(540, yKaart + kaartH * 0.4, 60, 540, yKaart + kaartH * 0.4, 700);
      g.addColorStop(0, '#fff6e2'); g.addColorStop(1, '#e8eff5');
      ctx.fillStyle = g; ctx.fillRect(xKaart, yKaart, kaartW, kaartH);
      var schaal = kaartW / (sv[2] - sv[0]);
      lagen.forEach(function (l) {
        var b = BEELD[l.n];
        ctx.drawImage(l.i, xKaart + (b.x - sv[0]) * schaal, yKaart + (b.y - sv[1]) * schaal, b.w * schaal, b.h * schaal);
      });
      ctx.restore();
      var yTekst = yKaart + kaartH + 90;
      ctx.fillStyle = '#1a1a1a';
      ctx.font = '600 44px ' + body;
      var breed = masImg ? 640 : 900;
      regels(ctx, T.zin, breed).forEach(function (t, i) { ctx.fillText(t, 90, yTekst + i * 58); });
      if (masImg) ctx.drawImage(masImg, 1080 - 90 - 290, yKaart + kaartH + 34, 290, 210);
      ctx.fillStyle = '#ffc107';
      rondRect(ctx, 90, 1920 - 190, 900, 100, 26); ctx.fill();
      ctx.lineWidth = 4; ctx.strokeStyle = '#1a1a1a'; ctx.stroke();
      ctx.fillStyle = '#1a1a1a';
      ctx.font = '700 40px ' + body;
      ctx.textAlign = 'center';
      ctx.fillText('Speel mee op speelgoes.nl', 540, 1920 - 126);
      ctx.textAlign = 'left';
      return new Promise(function (ok, fout) {
        try { c.toBlob(function (b) { b ? ok(b) : fout(new Error('leeg')); }, 'image/png'); } catch (e) { fout(e); }
      });
    }).then(function (blob) {
      var naam = 'speelgoes-bouwer-' + T.kop.toLowerCase().replace(/\s+/g, '-') + '.png';
      var file = null;
      try { file = new File([blob], naam, { type: 'image/png' }); } catch (e) {}
      if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
        status('');
        return navigator.share({ files: [file], title: 'Ik ben ' + T.naam }).then(function () { meld('deel', { methode: 'share', kanaal: 'story' }); }).catch(function () {});
      }
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url; a.download = naam;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
      status('Opgeslagen. Je vindt hem bij je downloads.');
      meld('deel', { methode: 'download', kanaal: 'story' });
    }).catch(function () {
      status('Dat lukte niet. Maak anders een schermafbeelding van je huisje.');
    }).then(function () { knop.disabled = false; });
  }

  function start(via) {
    keuzes = [null, null, null];
    ronde = 0; fase = 0; deelCode = null;
    stopDraai();
    verdiepingTerug();
    wortel.classList.remove('is-uitslag', 'is-gedeeld');
    wortel.classList.add('is-spel');
    intro.hidden = true;
    uitslag.hidden = true;
    spel.hidden = false;
    zetRonde();
    teken();
    meld('start', { via: via || 'pagina' });
    try {
      var u = new URL(location.href);
      if (u.searchParams.has('bq')) { u.searchParams.delete('bq'); history.replaceState(null, '', u.toString()); }
    } catch (e) {}
    vraagEl.focus({ preventScroll: true });
    kopRand();
    var top = wortel.getBoundingClientRect().top + window.scrollY - (parseInt(wortel.style.getPropertyValue('--spg-bq-boven'), 10) || 0);
    if (window.innerWidth < 990 && Math.abs(window.scrollY - top) > 10) window.scrollTo({ top: top, behavior: RUST ? 'auto' : 'smooth' });
    if (window.innerWidth < 990) setTimeout(function () {
      kopRand();
      var d = wortel.getBoundingClientRect().top - (parseInt(wortel.style.getPropertyValue('--spg-bq-boven'), 10) || 0);
      if (Math.abs(d) > 2) window.scrollBy({ top: d, behavior: 'auto' });
    }, RUST ? 60 : 700);
  }

  tegelsEl.addEventListener('click', function (e) {
    var t = e.target.closest('.spg-bq-tegel');
    if (t) { toets = e.detail === 0; kies(t.dataset.keuze); }
  });
  tikknop.addEventListener('click', function (e) { toets = e.detail === 0; tik(); });
  $('[data-bq-start]').addEventListener('click', function () { start('pagina'); });
  var andersKnop = $('[data-bq-anders]');
  if (andersKnop) andersKnop.addEventListener('click', opnieuwRonde);
  $('[data-bq-houd]').addEventListener('click', houd);
  $('[data-bq-deel]').addEventListener('click', deel);
  $('[data-bq-story]').addEventListener('click', story);
  $('[data-bq-nogmaals]').addEventListener('click', function () { meld('opnieuw', { ronde: 0 }); start('opnieuw'); });
  $('[data-bq-jij-start]').addEventListener('click', function () { start('deellink'); });
  Array.prototype.forEach.call(document.querySelectorAll('[data-bq-voor-keuze]'), function (b) {
    b.addEventListener('click', function () { if (b.dataset.bqVoorKeuze !== voorWie) zetVoor(b.dataset.bqVoorKeuze, true); });
  });

  function kopRand() {
    var onder = 0;
    try {
      var lijst = document.elementsFromPoint(Math.round(window.innerWidth / 2), 2);
      lijst.forEach(function (el) {
        for (var e = el; e && e !== document.body; e = e.parentElement) {
          if (wortel.contains(e)) return;
          var pos = getComputedStyle(e).position;
          if (pos === 'sticky' || pos === 'fixed') {
            var r = e.getBoundingClientRect();
            if (r.top <= 2 && r.bottom > onder && r.bottom < window.innerHeight * 0.4) onder = r.bottom;
            return;
          }
        }
      });
    } catch (e) {}
    wortel.style.setProperty('--spg-bq-boven', Math.round(onder) + 'px');
  }
  var kopTimer = null;
  window.addEventListener('scroll', function () {
    if (kopTimer) clearTimeout(kopTimer);
    kopTimer = setTimeout(function () { kopTimer = null; kopRand(); setTimeout(kopRand, 450); }, 150);
  }, { passive: true });
  window.addEventListener('resize', kopRand);
  var podiumH = 0;
  function podiumMaat() {
    var h = podium.offsetHeight;
    if (h === podiumH) return;
    podiumH = h;
    wortel.style.setProperty('--spg-bq-podium-h', h + 'px');
    if (laatsteKader) kader(laatsteKader);
  }
  var dokH = -1;
  function dokMaat() {
    var h = getComputedStyle(spel).position === 'sticky' && !spel.hidden ? spel.offsetHeight : 0;
    if (h === dokH) return;
    dokH = h;
    wortel.style.setProperty('--spg-bq-dok', h + 'px');
  }
  function laterNa(f) { var rij = false; return function () { if (rij) return; rij = true; requestAnimationFrame(function () { rij = false; f(); }); }; }
  if (window.ResizeObserver) { new ResizeObserver(laterNa(podiumMaat)).observe(podium); new ResizeObserver(laterNa(dokMaat)).observe(spel); }
  else window.addEventListener('resize', podiumMaat);
  window.addEventListener('resize', dokMaat);
  kopRand();

  laag('basis');
  laag('kat');
  toon('basis', true);
  toon('kat', true);
  kader(['basis', 'kat']);
  beschrijf();
  wortel.classList.add('is-klaar');

  var code = null;
  try { code = new URL(location.href).searchParams.get('bq'); } catch (e) {}
  if (code && /^[tsve]{3}$/.test(code)) {
    toonUitslag(code, true);
  } else {
    voorlaad(['romp', 'verd', 'dak', 'hoog'].concat(laadLijst(0)));
  }
})();
